import { CarPdfViewer } from "@app/components/PdfViewer";
import { useSearchParams } from "react-router-dom";
import { CarPdfDocument } from "@app/components/PdfDocument";
import { CarPdfPage, defaultClientPageSize } from "@app/components/PdfPage";
import { useUser } from "@app/pages/settings/useUser";
import { assetClassAnalysisPages } from "@app/const/route.const";
import { useAssetClassAnalysisIndexCompare } from "../useAssetClassAnalysisIndexCompare";
import { IndexComparePdfChart } from "./IndexComparePdfChart";
import { IndexCompareSummaryPdfTable } from "./IndexCompareSummaryPdfTable";

const INDEX_COMPARE_CHART_HEIGHT = 370;

export const PdfIndexCompareReportPage = () => {
  const [searchParams] = useSearchParams();
  const { assetClass1Id, assetClass2Id, assetClass3Id } =
    assetClassAnalysisPages.getPdfIndexCompareReportParams(searchParams);

  const data = useAssetClassAnalysisIndexCompare({
    data1Id: assetClass1Id,
    data2Id: assetClass2Id,
    data3Id: assetClass3Id,
  });

  const user = useUser();

  const ac1Label = data.items.find((i) => i.level4Id === assetClass1Id)?.name;
  const ac2Label = data.items.find((i) => i.level4Id === assetClass2Id)?.name;
  const ac3Label = data.items.find((i) => i.level4Id === assetClass3Id)?.name;

  const labels = [ac1Label, ac2Label, ac3Label].filter(Boolean).join(" vs. ");

  const title = `Index Compare ${labels}`;
  const footer = "Asset Class Analysis";

  return (
    <CarPdfViewer isLoading={user.isLoading || data.isLoading}>
      <CarPdfDocument title={title} author={user.userFullName}>
        {
          <CarPdfPage
            reportTitle="Index Compare"
            sectionTitle="Historical Analysis"
            footer={footer}
          >
            <IndexComparePdfChart
              style={{ marginTop: 18 }}
              width={defaultClientPageSize.width}
              height={INDEX_COMPARE_CHART_HEIGHT}
              item1={data.item1}
              item2={data.item2}
              item3={data.item3}
              isWhiteContext
            />
            <IndexCompareSummaryPdfTable
              break
              item1={data.item1}
              item2={data.item2}
              item3={data.item3}
            />
          </CarPdfPage>
        }
      </CarPdfDocument>
    </CarPdfViewer>
  );
};
